module.exports = __webpack_public_path__ + "img/Candy_Huster_2025.d3dd55e5.jpg";